export default __webpack_public_path__ + "static/media/notFound404.4ce18fbb.svg";